import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
});

export const totp: TRuleWithTheme = ({ theme }) => ({
    overflow: 'hidden',

    marginRight: '1.25rem',

    ...theme.typography.Password,
});

export const title: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',

    gap: '0.5rem',

    marginBottom: '0.75rem',
});

export const text: TRuleWithTheme = () => ({
    marginBottom: '1.75rem',
});
